export default __webpack_public_path__ + "static/media/a2.c3c8a40b.png";